module.exports = __webpack_public_path__ + "static/media/DSC01902.bb2dca5f.jpg";